import agentEducationPage from 'src/helpers/flows/pages/default/agentEducationPage';
import agentVerificationPage from 'src/helpers/flows/pages/default/agentVerificationPage';
import basicDataPage from 'src/helpers/flows/pages/default/basicDataPage';
import entryTypePage from 'src/helpers/flows/pages/default/entryTypePage';
import homebuilderDetailsPage from 'src/helpers/flows/pages/default/homebuilderDetailsPage';
import homebuilderNamePage from 'src/helpers/flows/pages/default/homebuilderNamePage';
import homebuilderPage from 'src/helpers/flows/pages/default/homebuilderPage';
import listingAgentPage from 'src/helpers/flows/pages/default/listingAgentPage';
import sellerInformPage from 'src/helpers/flows/pages/exclusives/sellerInformPage';
import willingnessForTourPage from 'src/helpers/flows/pages/exclusives/willingnessForTourPage';
import { FlowPageSet } from 'src/lib/flow/FlowPage';

import accountPage from '../pages/default/accountPage';
import kitchenAppliancePage from '../pages/default/kitchenAppliancePage';
import dwellingTypePage from '../pages/exclusives/dwellingTypePage';
import eligibilityCriteriaPage from '../pages/exclusives/eligibilityCriteriaPage';
import exclusivesDelayPage from '../pages/exclusives/exclusivesDelayPage';
import hoaGuardPage from '../pages/exclusives/hoaGuardPage';
import homeInformPage from '../pages/exclusives/homeInformPage';
import kitchenCounterPage from '../pages/exclusives/kitchenCounterPage';
import phoneNumberPage from '../pages/exclusives/phoneNumberPage';
import priceEstimatePage from '../pages/exclusives/priceEstimatePage';
import relationshipPage from '../pages/exclusives/relationshipPage';
import saleTimelinePage from '../pages/exclusives/saleTimelinePage';
import sellerInterestPage from '../pages/exclusives/sellerInterestPage';
import {
  bathroomCondition,
  exteriorCondition,
  kitchenCondition,
  livingRoomCondition,
} from '../pages/roomCondition';

const homebuilderPageSet = [homebuilderPage, homebuilderNamePage, homebuilderDetailsPage];

const relationshipPageSet = [relationshipPage, listingAgentPage, agentEducationPage];

const RoomConditionPageSet: FlowPageSet = [
  kitchenCondition,
  bathroomCondition,
  livingRoomCondition,
  exteriorCondition,
];

const valuationsPageSet = [
  dwellingTypePage,
  basicDataPage,
  kitchenCounterPage,
  kitchenAppliancePage,
  hoaGuardPage,
  ...RoomConditionPageSet,
  entryTypePage,
  eligibilityCriteriaPage,
];

export const exclusivesPageSet: FlowPageSet = [
  sellerInterestPage,
  sellerInformPage,
  ...relationshipPageSet,
  saleTimelinePage,
  willingnessForTourPage,
  homeInformPage,
  ...valuationsPageSet,
  ...homebuilderPageSet,
  priceEstimatePage,
  accountPage,
  phoneNumberPage,
  agentVerificationPage,
  exclusivesDelayPage,
];
